import { Avatar, Box, Typography } from '@mui/material'
import { PROFILE_IMAGE_TYPE } from 'Queries/utils'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { userImageSelector } from 'utils/user-images-utils'

export const UserInfo = ({ handleUserClick, isWaypointUser, userImages, login, info, sx = {} }) => (
  <Box
    sx={(theme) => ({ display: 'flex', gap: 1, cursor: 'pointer', ...(typeof sx === 'function' ? sx(theme) : sx) })}
    onClick={handleUserClick}
  >
    {!isWaypointUser ? (
      <Avatar
        src={userImageSelector(userImages, PROFILE_IMAGE_TYPE.AVATAR, 'medium')}
        size="normal"
      />
    ) : (
      <FAIcon
        iconClassName={FA_ICONS.XBOX}
        iconFontSize={40}
      />
    )}
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography
        variant="h6"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100px',
        }}
      >
        {login}
      </Typography>
      <Typography
        color="text.tertiary"
        sx={{ fontSize: '12px', lineHeight: '24px', fontFamily: 'Poppins', fontWeight: 500 }}
      >
        {info}
      </Typography>
    </Box>
  </Box>
)
